const ACCESS_CODE_KEY = 'ontime_access_code';

class AccessCodeService {
    /**
     * Get the access code from session storage
     */
    getAccessCode(): string | null {
        return sessionStorage.getItem(ACCESS_CODE_KEY);
    }

    /**
     * Set the access code in session storage
     */
    setAccessCode(code: string): void {
        sessionStorage.setItem(ACCESS_CODE_KEY, code);
    }

    /**
     * Clear the access code from session storage
     */
    clearAccessCode(): void {
        sessionStorage.removeItem(ACCESS_CODE_KEY);
    }

    /**
     * Check if an access code is set
     */
    hasAccessCode(): boolean {
        return this.getAccessCode() !== null;
    }
}

const AccessCodeServiceInstance = new AccessCodeService();

export default AccessCodeServiceInstance;
